import React from "react";
import { Box, Typography } from "@mui/material";
import FirstLineContainer from "components/common/FirstLineContainer";

const TopPanelComponent = () => {
  return (
    <FirstLineContainer>
      <Typography variant="h6" sx={{ textAlign: "left", flex: 1 }}>
        <Box component="span" fontWeight="fontWeightBold">
          Policy Adoption History
        </Box>
      </Typography>
    </FirstLineContainer>
  );
};

export default TopPanelComponent;
